import { Link } from "@reach/router";
import React from "react";
import { useSelector } from "react-redux";
import {
  FooterType,
  NavigationFooterData,
  selectFooter,
  UpdateProfileFooterData,
} from "reducers/footer";
import TwitterIcon from "../../assets/Icon_Social_02.png";
import FacebookIcon from "../../assets/Icon_Social_04.png";
import InstagramIcon from "../../assets/Icon_Social_05.png";
import { NavigationFooter } from "./NavigationFooter";
import { UpdateProfileFooter } from "./UpdateProfileFooter";

export const FooterSocials: React.FC = () => (
  <div className="Socials">
    <a
      href="https://www.facebook.com/clevryCOM"
      className="Social"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={FacebookIcon} alt="SocialIcon" />
    </a>
    <a
      href="https://twitter.com/ClevryGroup"
      className="Social"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={TwitterIcon} alt="SocialIcon" />
    </a>
    <a
      href="https://www.instagram.com/clevry.group/"
      className="Social"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={InstagramIcon} alt="SocialIcon" />
    </a>
  </div>
);

export const FooterCopyright: React.FC = () => (
  <div className="FooterCopyright">
    <p className="Copyright">
      <span>
        Copyright &#169;{new Date().getFullYear()} AVAMAE. All rights reserved.
        | Website development by{" "}
        <a href="https://www.avamae.co.uk/" target="_blank">
          <u>AVAMAE</u>
        </a>
      </span>
    </p>
  </div>
);

export const FooterLegalLinks: React.FC = () => {
  const handleTandCNav = () => {
    // dispatch(toOtherNav({ title: "Terms and conditions" }))
  };
  const handlePrivacyNav = () => {
    // dispatch(toOtherNav({ title: "Privacy policy" }))
  };
  const setAccessibility = () => {
    // dispatch(toOtherNav({ title: "Privacy policy" }))
  };

  return (
    <>
      <Link
        to="/terms-and-conditions"
        className="FooterLink"
        onClick={handleTandCNav}
      >
        Terms and conditions
      </Link>
      <Link
        to="/privacy-policy"
        className="FooterLink"
        onClick={handlePrivacyNav}
      >
        Privacy policy
      </Link>
      <Link to="" className="FooterLink" onClick={setAccessibility}>
        Turn on accessibility mode
      </Link>
    </>
  );
};

interface FooterProps {
  isThemed: boolean;
}

const Footer: React.FC<FooterProps> = ({ isThemed }) => {
  const { data, footerType } = useSelector(selectFooter);

  // Don't include NavigationFooter in Footer div as it doesn't obey the same
  // syling rules.
  if (footerType === FooterType.NAVIGATION_FOOTER) {
    return (
      <div className={`NavigationFooterContainer  ${isThemed ? "Themed" : ""}`}>
        <NavigationFooter {...(data as NavigationFooterData)} />
      </div>
    );
  }
  if (footerType === FooterType.NONE) {
    return null;
  }

  return (
    <footer className="Footer">
      <div className="LeftContent">
        <FooterSocials />
        <div className="FooterLinks LoggedInFooter">
          <FooterLegalLinks />
        </div>
      </div>
      <FooterCopyright />
    </footer>
  );
};

export { Footer };
